module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form', {
    attrs: {
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "选择日期范围"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "daterange",
      "alue-format": "yyyy-MM-dd",
      "align": "right",
      "unlink-panels": "",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期",
      "picker-options": _vm.pickerOptions,
      "value-format": "yyyy-MM-dd"
    },
    on: {
      "change": _vm.dateChange
    },
    model: {
      value: (_vm.vdate),
      callback: function($$v) {
        _vm.vdate = $$v
      },
      expression: "vdate"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.exportloading),
      expression: "exportloading"
    }],
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.exportData
    }
  }, [_vm._v("导出")]), _vm._v(" "), _c('el-popover', {
    attrs: {
      "placement": "top-start",
      "width": "200",
      "trigger": "hover",
      "content": "导出任务会以队列执行，点击导出后，请至‘设置-导出列表’页面中查看及下载数据"
    }
  }, [_c('i', {
    staticClass: "el-icon-question",
    attrs: {
      "slot": "reference"
    },
    slot: "reference"
  })])], 1)], 1)], 1), _vm._v(" "), (_vm.$route.path.indexOf('_editor') === -1) ? _c('el-tabs', {
    attrs: {
      "type": "border-card"
    },
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "label": "商品统计",
      "name": "goods_count"
    }
  }, [
    [_c('el-table', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "data": _vm.allListData,
        "stripe": "",
        "border": "",
        "height": _vm.wheight - 230
      }
    }, [_c('el-table-column', {
      attrs: {
        "prop": "no",
        "label": "No"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "sap_code",
        "label": "商品编号"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "top_level",
        "label": "分类"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "product",
        "label": "商品名称"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "quantity",
        "label": "销量"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "fix_price",
        "label": "销售额"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "settle_price",
        "label": "实付额"
      }
    })], 1)]
  ], 2)], 1) : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1df79d48", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1df79d48"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/mall/datacube/goodsdata.vue
// module id = 2519
// module chunks = 0